module.exports = __webpack_public_path__ + "static/media/gabr_color.d2737a3b.png";